import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { DirectCampaignModel } from './types';

export const selectMetrics = createSelector(
    [(state: RootState) => state.direct.metrics],
    (metrics) => metrics,
);

export const selectDirectCampaignsLoading = createSelector(
    [(state: RootState) => state.direct.campaigns.isLoading],
    (isLoading) => isLoading,
);

export const selectDirectCampaignsRecords = createSelector(
    [(state: RootState) => state.direct.campaigns.records],
    (records) => records,
);

export const selectDirectCampaigns = createSelector(
    [selectDirectCampaignsRecords],
    (records): DirectCampaignModel[] | undefined => {
        if (!records) {
            return undefined;
        }

        return Object.values(records);
    },
);

export const selectDirectCampaignSaving = createSelector(
    [(state: RootState) => state.direct.isSaving],
    (isSaving) => isSaving,
);

export const selectDirectLogins = createSelector(
    [(state: RootState) => state.direct.logins.items],
    (logins) => logins,
);

export const selectDirectLoginsLoading = createSelector(
    [(state: RootState) => state.direct.logins.isLoading],
    (isLoading) => isLoading,
);
